(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

if ((typeof Shopify) === 'undefined') { Shopify = {}; }
jQuery(document).ready(function($){
    var isAjaxFilterClick =  false;
    if ($(".Sidebar")) {
        History.Adapter.bind(window, 'statechange', function() {
            var State = History.getState();
            if (!isAjaxFilterClick) {
                ajaxFilterParams();
                var newurl = ajaxFilterCreateUrl();
                ajaxFilterGetContent(newurl);
            }
            Shopify.isSidebarAjaxClick = false;
        });
    }
    ajaxFilterParams = function () {
        Shopify.queryParams = {};
        if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');
                if (aKeyValue.length > 1) {
                    Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }
    }
    ajaxFilterCreateUrl = function(baseLink) {
        var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      	
        if (baseLink) {
            if (newQuery != "")
                return baseLink + "?" + newQuery;
            else
                return baseLink;
        }
        return location.pathname + "?" + newQuery;
    }
    ajaxFilterClick = function(baseLink) {
        var newurl = ajaxFilterCreateUrl(baseLink);
        isAjaxFilterClick = true;
        History.pushState({
            param: Shopify.queryParams
        }, newurl, newurl);
        ajaxFilterGetContent(newurl);
    }
    ajaxFilterView = function() {
      	
        $('.filter-item a').click(function(e) {
          	$(this).toggleClass('active');
          	var currentTags = [];

            if (Shopify.queryParams.constraint) {
                currentTags = Shopify.queryParams.constraint.split('+');
            }
          	if (!window.filter_mul_choice && !$(this).prev().is(":checked")) {
                var otherTag = $(this).parents('.filter-item').find("input:checked");
                if (otherTag.length > 0) {
                    var tagName = otherTag.val();
                    if (tagName) {
                      var tagPos = currentTags.indexOf(tagName);
                        if (tagPos >= 0) {
                            currentTags.splice(tagPos, 1);
                        }
                    }
                }
            }

            var tagName = $(this).prev().val();
            if (tagName) {
                var tagPos = currentTags.indexOf(tagName);
                if (tagPos >= 0) {
                    currentTags.splice(tagPos, 1);
                } else {
                    currentTags.push(tagName);
                }
            }
			if (currentTags.length) {
              	$(".filter-actions").show(300);
            	Shopify.queryParams.constraint = currentTags.join('+');
            } else {
              	$(".filter-actions").hide(300);
                delete Shopify.queryParams.constraint;
            }
          	ajaxFilterClick();
        	e.preventDefault();
        });
        $(".changeView").click(function(event) {
            event.preventDefault();
            if (!$(this).hasClass("changeViewActive")) {
                if ($(this).data('view') == 'list' ) {
                    Shopify.queryParams.view = "list";
                  	$(".filters-toolbar").addClass('add-list');
                } else {
                    Shopify.queryParams.view = "grid";
                  	$(".filters-toolbar").removeClass('add-list');
                }
                $(".changeView").removeClass('changeViewActive');
                $(this).addClass('changeViewActive');
                ajaxFilterClick();
              	event.preventDefault();
            }
        });
      	$(".filter-actions a").click(function(event) {
          	$('.filter-item a').removeClass('active');
            delete Shopify.queryParams.constraint;
          	ajaxFilterClick();
          	$(".filter-actions").hide(300);
        });
    }
    
    ajaxFilterData = function(data){
        var currentList = $(".proView");
        var dataList = $(data).find(".proView");
        currentList.replaceWith(dataList);
        if ($(".pagination").length > 0) {
            $(".pagination").replaceWith($(data).find(".pagination"));
        } else {
            $(".pagination").append($(data).find(".pagination"));
        } 
    }
    ajaxFilterGetContent = function(newurl) {
        $.ajax({
            type: 'get',
            url: newurl,
            beforeSend: function() {
                $('.loading').show();
            },
            success: function(data) {
                ajaxFilterData(data);
				
                $('.loading').hide();
              	var newTitle = $(data).filter('title').text();
                document.title = newTitle;
            },
            error: function(xhr, text) {
                $('#loading').hide();

            }
        });
    }
    ajaxFilterParams();
    ajaxFilterView();
} );

jQuery(document).ready(function($){
    if ($(".templateProduct").length) {
          
          ajaxSwatchColor = function() {
              var dataProduct = $(".templateProduct .product-single").data('handle');
              jQuery.getJSON('/products/' + dataProduct + '.js', function (product) { 
                  var i;
                  for(i=0;i < product.options.length;i++){
                    var swatch = product.options[i].name;
                    var swatchValue = product.options[i].values;
                    if(swatch.toLowerCase() == 'color' || swatch.toLowerCase() == 'colour'){
                        var j;
                        for(j=0;j < swatchValue.length;j++){
                            var swatchValueJ = swatchValue[j];
                            var swatchValueLowerCase = swatchValueJ.toLowerCase();
                            var k;
                            for(k=0;k < product.variants.length;k++){
                                var options = product.variants[k].options;
                                if(options.indexOf(swatchValueJ) != -1){
                                      var src = product.variants[k].featured_image.src;
                                      $('#product-'+product.id+' .proVariants .'+swatchValueLowerCase+' label').css("background-image", 'url('+theme.resizeImage(src, 'compact')+')');
                                }
                            }
                        }
                    }
                  }
              });
          }
          ajaxSwatchColor();
        
    }
});

jQuery(document).ready(function($){
  		var owl = $(".owl.owl-carousel");
	    owl.each(function(){
        var $item = $(this).data('item-slide');
		var $rtl = $(this).data('ow-rtl');
		var $dots = ($(this).data('dots') == true) ? true : false;
		var $nav = ($(this).data('nav') == false) ? false : true;
		var $margin = ($(this).data('margin')) ? $(this).data('margin') : 0;
		var $desksmall_items = ($(this).data('desksmall')) ? $(this).data('desksmall') : (($item) ? $item : 4);
		var $tablet_items = ($(this).data('tablet')) ? $(this).data('tablet') : (($item) ? $item : 2);
		var $tabletsmall_items = ($(this).data('tabletsmall')) ? $(this).data('tabletsmall') : (($item) ? $item : 2);
		var $mobile_items = ($(this).data('mobile')) ? $(this).data('mobile') : (($item) ? $item : 1);
		var $tablet_margin = Math.floor($margin / 1.5);
		var $mobile_margin = 0;
		var $default_items = ($item) ? $item : 5;
		
		var $autoplay = ($(this).data('autoplay') == true) ? true : false;
		var $autoplayTimeout = ($(this).data('playtimeout')) ? $(this).data('playtimeout') : 5000;
		var $smartSpeed = ($(this).data('speed')) ? $(this).data('speed') : 250;
		var $loop = false;
		
		$(this).owlCarousel({
			loop : $loop,
			nav : $nav,
			dots: $dots,
			margin: $margin,
			rtl: $rtl,
			items : $default_items,
			autoplay: $autoplay,
          	autoplayTimeout: $autoplayTimeout,
			smartSpeed: $smartSpeed,
			responsive:{
				0:{
			      items: $mobile_items, // In this configuration 1 is enabled from 0px up to 479px screen size 
				  margin: $mobile_margin
			    },

			    480:{
			      items: $tabletsmall_items, // from 480 to 677 default 1
				  margin: $tablet_margin
			    },

			    640:{
			      items: $tablet_items, // from this breakpoint 678 to 959 default 2
				  margin: $tablet_margin
			    },

			    991:{
			      items: $desksmall_items, // from this breakpoint 960 to 1199 default 3
				  margin: $margin

			    },
			    1199:{
			      items:$default_items,
			    }
			}
		});
	});
});//end of document ready
jQuery(document).ready(function($) {
    function loadmoreExecute() {
        var LoadNode = $('#bst-Product-LoadMore .btnLoadMore');
        var LoadUrl = $('#bst-Product-LoadMore .btnLoadMore').attr("href");
        $.ajax({
            type: 'GET',
            url: LoadUrl,
            beforeSend: function() {
                $('#loading').show();
            },
            success: function(data) {
                LoadNode.remove();
                $('#loading').hide();
                var filteredData = $(data).find(".bst-collections-productgird");
                filteredData.insertBefore($(".proLoadMoreBottom"));
                btnMoreEvent();
            },
            dataType: "html"
        });
    }
    function btnMoreEvent(){
        $('#bst-Product-LoadMore .btnLoadMore').click(function(e){
            if ($(this).hasClass('disableLoadMore')) {
                e.stopPropagation();
                return false;
            }
            else {
                loadmoreExecute();
                e.stopPropagation();
                return false;
            }
        });
    }
    btnMoreEvent();
});

jQuery(document).ready(function($){
  	var id_handle = $('#collection-handle');
    if(id_handle){
      	var data_handle = id_handle.data('collection-handle');
        jQuery.getJSON('/collections/'+data_handle+'/products.json?sort_by=best-selling', function (collections) {
          	var html = '';
          	$.each(collections.products, function(i, item) {
              	jQuery.getJSON('/products/' + item.handle + '.js', function (product) {
                    var listproduct = $('.listproduct'+i+'');
        			listproduct.find('.bst-productName a').html(product.title).attr('href', product.url);
                	listproduct.find('.priceProduct').html(theme.Currency.formatMoney(product.price, theme.moneyFormat));
                    if (product.compare_at_price > product.price) {
						listproduct.find('.priceCompare').html(theme.Currency.formatMoney(product.compare_at_price_max, theme.moneyFormat)).show();
                    }else{
                    	listproduct.find('.priceCompare').remove();
                    }
                  	//out of stock
                    if (!product.available) {
                      html = '<button class="btnAddToCart disabled add_to_cart_inline" type="submit" value="Submit" disabled><span>Out Of Stock</span></button>';
                      listproduct.find('.formAddToCart').append(html);
                    } else {
                      if (product.variants.length > 1) {
                      	html = '<a class=" btnAddToCart add_to_cart_inline" href="'+product.url+'" title="Select Options"><span class="select_options">Select Options</span></a>';
                      	listproduct.find('.formAddToCart').append(html);
                      }else{
                      	html = '<button class=" btnAddToCart add_to_cart_inline" type="submit" value="Submit"><span>Add to cart</span></button>';
                      	listproduct.find('.formAddToCart').append(html);
                      }
                    }
                  	listproduct.find('.btnProductQuickview').attr('data-id', product.handle);
                  	listproduct.find('.action--wishlist').attr('data-product-id', product.handle);
                  	listproduct.find('.bst-product-thumbnail').attr('href', product.url);
                  	listproduct.find('.formAddToCart input').val(product.variants[0].id);
                  	listproduct.find('.primary_image').attr('src',theme.resizeImage(product.featured_image, 'grande'));
                });
                if( i == 9){
					return false;
                }
            });
          	
          	
        });
    }
});


jQuery(document).ready(function($){
  	"use strict";
  	var number_click = 1;
    $(".qty-down-fixed-onclick").click(function() {
		var val_input = $(this).closest('div.quantity').find('.input-text').val();
		val_input = parseInt(val_input);
		if(val_input <= number_click){
			val_input = number_click;
		}
		else{
			val_input = val_input - number_click;
		}
		$(this).closest('div.quantity').find('.input-text').val(val_input);
		return false;
	});
	$(".qty-up-fixed-onclick").click(function() {
		var val_input = $(this).closest('div.quantity').find('.input-text').val();
		val_input = parseInt(val_input);
		val_input = val_input + number_click;
		$(this).closest('div.quantity').find('.input-text').val(val_input);
		return false;
	});
  
  
  	// Qty QuickView
  	$(document).on('click', '.QuickView .qty-down-fixed-onclick', function(){
		var val_input_quickview = $(this).closest('div.quantity').find('.input-text').val();
      	alert(val_input_quickview);
		val_input_quickview = parseInt(val_input_quickview);
		if(val_input_quickview <= number_click){
			val_input_quickview = number_click;
		}
		else{
			val_input_quickview = val_input_quickview - number_click;
		}
		$(this).closest('div.qty').find('.input-text').val(val_input_quickview);
		return false;
	});
 	$(document).on('click', '.QuickView .qty-up-fixed-onclick', function(){
		var val_input_quickview = $(this).closest('div.quantity').find('.input-text').val();
		val_input_quickview = parseInt(val_input_quickview);
		val_input_quickview = val_input_quickview + number_click;
		$(this).closest('div.quantity').find('.input-text').val(val_input_quickview);
		return false;
	});
  
  	// Scroll
	var currentP = 0;
	
	$(window).scroll(function(){
		var headerH = $('.header-type').height();
		var scrollP = $(window).scrollTop();
		
		if($(window).width() > 1024){
			if(scrollP != currentP){
				//Back to top
				if(scrollP >= headerH){
					$('#back-top').addClass('show');
				} else {
					$('#back-top').removeClass('show');
				}
				
				currentP = $(window).scrollTop();
			}
		}
	});
  	
  	$(document).on('click', '#back-top', function(){
		$("html, body").animate({ scrollTop: 0 }, "slow");
	});
 
  	$( document ).ready(function() {
		//before load
		window.addEventListener('beforeunload', function () {
			if (document.getElementsByClassName('enable_page_preloader')[0]) {
				var themeContainer = document.getElementById('homess-main-wrapper');
				if (themeContainer) {
					themeContainer.classList.add('is-loading');
					themeContainer.classList.remove('is-ready');
				}
			}
		});
		
		//done load
		window.addEventListener('load', function () {
			if (document.getElementsByClassName('enable_page_preloader')[0]) {
				var themeContainer = document.getElementById('homess-main-wrapper');
				if (themeContainer) {
					themeContainer.classList.remove('is-loading');
					themeContainer.classList.add('is-ready');
				}
				NProgress.done();
			}
		});
	});
});
jQuery(document).ready(function($) {
	$(document).on('click', '.site-header__search', function(){
		$(this).closest('.block-search').find('.bst-search-header').toggle(500);
	});
	
	$(document).on('click', '.site-header__cart', function(){
		$(this).closest('.cart-open').find('#bst-minicart').toggle(500);
	});
    $(document).on("click", function(event){
        var $trigger = $(".load-js .site-header__search");
        var $trigger_cart = $(".site-header__cart");
		if($trigger_cart !== event.target && !$trigger_cart.has(event.target).length){
            $("#bst-minicart").slideUp(500);
        }
        if($trigger !== event.target && !$trigger.has(event.target).length){
            $(".load-js .bst-search-header").slideUp(500);
        }
    });
});

jQuery(document).on('click', '.nav-mobile .toggle-menu, .mobile-menu-overlay', function(){
	$('body').toggleClass('mobile-nav-on');
});

jQuery(document).on('click', '.nav-vertical-mobile .toggle-menu, .mobile-menu-overlay', function(){
	$('body').toggleClass('vertical-mobile-nav-on');
});

jQuery(document).on('click', '#close-verticalmenu-moblie a', function(){
	$('body').removeClass('vertical-mobile-nav-on');
});

jQuery(document).on('click', '#close-menu-moblie a', function(){
	$('body').removeClass('mobile-nav-on');
});

jQuery(document).on('click', '.filters-toolbar-wrapper .filters-on-mobile', function(){
	$('body').addClass('filter-mobile-on');
});
jQuery(document).on('click', '#shopify-section-BlueskyTechco-Slidebar .close-filter-mobile', function(){
	$('body').removeClass('filter-mobile-on');
});
jQuery(document).on('click', '.vertical-menu .block-title', function(){
  	$(this).toggleClass("active");
  	$(this).parent().toggleClass("has-open");
});
jQuery(document).on("click",".open-cate",function(e){
 	$(this).closest(".block-nav-category").find("li.link-other").each(function(){
      	$(this).slideDown();
    });
  	$(this).addClass("close-cate").removeClass("open-cate").html($(this).data("closetext"));
});
jQuery(document).on("click",".close-cate",function(e){
 	$(this).closest(".block-nav-category").find("li.link-other").each(function(){
      	$(this).slideUp();
    });
  	$(this).addClass("open-cate").removeClass("close-cate").html($(this).data("alltext"));
});

jQuery(document).ready(function($){
  	$(this).each(function(){
		var items = $('.vertical-category-block').data("items");
        if(!items){
          items = 10;
        }
		var e = $(this).find(".block-nav-category .verticalmenu>li").length;
        if( e <= items){
          	$(".view-all-category").remove();
        }else{
        	$( ".block-nav-category .verticalmenu>li" ).each(function( index, element ) {
              	items = $('.block-nav-category').data("items");
              	if(!items){
                  items = 10;
      			}
                if(index >= items){
                  	$(".block-nav-category .verticalmenu>li").eq(index).addClass("link-other");
                  	$(".block-nav-category .verticalmenu>li").eq(index).slideUp();
                }
            });
        }	
	});
  	var url = $('.bst-Collection-Tab .nav .active.show').data('url');
  	$('.view-more-roducts').find('a').attr('href', url);
    $('.bst-Collection-Tab .nav a').click(function() {
      if(!$(this).hasClass('active')){
        var dataurl = $(this).data('url');
        var datatabid = $(this).data('tabid');
        $(this).closest(".bst-Collection-Tab").find('.nav-collection-tab a').attr('href', dataurl);
        $(this).closest(".bst-Collection-Tab").find('.bst-tab-main-content .tab-pane').slideUp("slow");
        $(this).closest(".bst-Collection-Tab").find('.bst-tab-main-content #'+datatabid).slideDown("slow");
      }
    });
});

jQuery(document).on('click', '.mobile-menu li.dropdown .toggle-submenu', function(){
    if($(this).parent().hasClass('opening')){
        $(this).parent().removeClass('opening').children('ul').stop().slideUp(200);
        $(this).parent().children('.toggle-submenu').children('.fa').removeClass('fa-minus').addClass('fa-plus');
    }else{
        $(this).parent().addClass('opening').children('ul').stop().slideDown(200);
        $(this).parent().children('.toggle-submenu').children('.fa').removeClass('fa-plus').addClass('fa-minus');
    }
});

jQuery(document).on('click', '.bst-vertical-mobi li.dropdown .toggle-submenu', function(){
    if($(this).parent().hasClass('opening')){
        $(this).parent().removeClass('opening').children('ul').stop().slideUp(200);
        $(this).parent().children('.toggle-submenu').children('.fa').removeClass('fa-minus').addClass('fa-plus');
    }else{
        $(this).parent().addClass('opening').children('ul').stop().slideDown(200);
        $(this).parent().children('.toggle-submenu').children('.fa').removeClass('fa-plus').addClass('fa-minus');
    }
});
jQuery(window).bind('load', function () {
	var gallery = $('.product-single__photos .flex-control-nav');
	if (gallery.size() && gallery.children().size()) {
		gallery.jcarousel({
			vertical: gallery.closest('.product-single__photos').hasClass('vertical-right-slider') || gallery.closest('.product-single__photos').hasClass('vertical-left-slider'),
			scroll: 1,
			visible: $('.single-product-image').data('columns'),
			buttonNextHTML: '<span class="next-ctl-button-fixed">Next</span>',
			buttonPrevHTML: '<span  class="prev-ctl-button-fixed">Prev</span>',
			compareElement: '.single-product-image',
			mainContainer: '.product-single__photos'
		});
	}
}); 
jQuery(document).ready(function($){
	$('.zoomImage').zoom();
}); 
jQuery(document).ready(function($){
  $('.layout_2').on('click',function(){
      $(this).addClass('active');
      $('.grid_item').addClass('col-sm-6').removeClass('col-sm-3').removeClass('col-sm-4').removeClass('col-sm-2').removeClass('col-sm-50');
      $('.layout_3').removeClass('active');
      $('.layout_4').removeClass('active');
      $('.layout_5').removeClass('active');
      $('.layout_6').removeClass('active');
      $('.proViewgrid').addClass('layout2').removeClass('layout6').removeClass('layout3').removeClass('layout4').removeClass('layout5');
  });
  $('.layout_3').on('click',function(){
      $(this).addClass('active');
      $('.grid_item').addClass('col-sm-4').removeClass('col-sm-2').removeClass('col-sm-3').removeClass('col-sm-6').removeClass('col-sm-50');
      $('.layout_2').removeClass('active');
      $('.layout_4').removeClass('active');
      $('.layout_5').removeClass('active');
      $('.layout_6').removeClass('active');
      $('.proViewgrid').addClass('layout3').removeClass('layout2').removeClass('layout4').removeClass('layout6').removeClass('layout5');
  });
 $('.layout_4').on('click',function(){
      $(this).addClass('active');
      $('.grid_item').addClass('col-sm-3').removeClass('col-sm-2').removeClass('col-sm-4').removeClass('col-sm-6').removeClass('col-sm-50');
      $('.layout_2').removeClass('active');
      $('.layout_3').removeClass('active');
      $('.layout_5').removeClass('active');
      $('.layout_6').removeClass('active');
      $('.proViewgrid').addClass('layout4').removeClass('layout2').removeClass('layout3').removeClass('layout6').removeClass('layout5');
  });
   $('.layout_5').on('click',function(){
      $(this).addClass('active');
      $('.grid_item').addClass('col-sm-50').removeClass('col-sm-2').removeClass('col-sm-3').removeClass('col-sm-6').removeClass('col-sm-4');
      $('.layout_4').removeClass('active');
      $('.layout_2').removeClass('active');
      $('.layout_3').removeClass('active');
      $('.layout_6').removeClass('active');
      $('.proViewgrid').addClass('layout5').removeClass('layout2').removeClass('layout3').removeClass('layout4').removeClass('layout6');
  });
   $('.layout_6').on('click',function(){
      $(this).addClass('active');
      $('.grid_item').addClass('col-sm-2').removeClass('col-sm-3').removeClass('col-sm-4').removeClass('col-sm-6').removeClass('col-sm-50');
      $('.layout_4').removeClass('active');
      $('.layout_5').removeClass('active');
      $('.layout_2').removeClass('active');
      $('.layout_3').removeClass('active');
      $('.proViewgrid').addClass('layout6').removeClass('layout2').removeClass('layout3').removeClass('layout4').removeClass('layout5');
  });
  
});

jQuery(document).ready(function($){
	setCookie = function(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      var expires = "expires="+d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie = function(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
    checkCookie = function() {
      var again = getCookie("not-again");
      var mobile = false;
      if (again != "") {   
      }else {
        if($(window).width() > 767){
        	$(window).on('load',function(){
              $('#myModal').modal('show');
            });
        }else{
            if(mobile == true){
				$(window).on('load',function(){
                  $('#myModal').modal('show');
                });
            }
        }
      } 
    }
    addCookie = function() {
      $('.not-again input').click(function(){
          var again = $(this).val();
          if($(this).prop("checked") == true){
            setCookie("not-again",again, 15);
          }
          else{
            setCookie("not-again",'', -15);
          }
      });
    }
    addCookie();
    checkCookie();
});
jQuery(document).ready(function($){
  	
        jQuery(document).on('click', '.swacth-image-thumb', function(){
          var swacth_img = $(this).data('swacth-img');
          $(this).closest('.ProductGird').find('.product-image .primary_image').attr('src', swacth_img);
          $(this).closest('.ProductGird').find('.product-image .secondary_image').attr('src', swacth_img);
          $(this).closest('.variant-image-group').find('.swacth-image a').removeClass('active');
          $(this).addClass('active');
        });
    
});

jQuery(document).ready(function($){
  var start = new Date;
  start.setHours(24, 0, 0);

  function pad(num) {
    return ("0" + parseInt(num)).substr(-2);
  }

  function tick() {
    var now = new Date;
    var _time = $('.countdow_page'),
		_hour = _time.find('.hr'),
		_minute = _time.find('.min'),
		_second = _time.find('.sc');
    if (now > start){
      start.setDate(start.getDate() + 1);
    }
    var remain = ((start - now) / 1000);
    var hh = pad((remain / 60 / 60) % 60);
    var mm = pad((remain / 60) % 60);
    var ss = pad(remain % 60);
	_hour.text(hh);
    _minute.text(mm);
    _second.text(ss);
    setTimeout(tick, 1000);
  }
  tick();
  document.addEventListener('DOMContentLoaded', tick);
  
  progressbar = function(e) {
    if ($(".templateProduct").length) {
      var dataProductID = $(".templateProduct .product-single").data('id');

      jQuery.getJSON('/admin/orders.json', function (orders) { 
        var sum = 0;
        $.each(orders, function(index, item) {
          $.each(item, function(indexi, itemi) {
              var proID = itemi.line_items;
              $.each(proID, function(indexj, itemj) {
                  if(itemj.product_id == dataProductID){
                      var num = itemj.quantity;
                      sum += (num || 0);
                  }
              });
          });
        });
        var variants = parseInt($(".countdow-product").find(".count").text());
        var l = $(".countdow-product");
        var count = variants+sum;
        var a = 100*(variants/count);
        l.find(".progressbar").addClass("active progress-striped");
        setTimeout(function() {
          l.find(".progressbar div").css("width", a + "%");
          l.find(".progressbar").removeClass("active progress-striped");
        }, 300)    
      });
      setInterval(function() {
          var sumqt = 0;
          jQuery.getJSON('/admin/orders.json', function (orders) { 
            $.each(orders, function(index, item) {
              $.each(item, function(indexi, itemi) {
                  var proID = itemi.line_items;
                  $.each(proID, function(indexj, itemj) {
                      if(itemj.product_id == dataProductID){
                          var numty = itemj.quantity;
                          sumqt += (numty || 0);
                      }
                  });
              });
            });
            var sumqty = 0;
            jQuery.getJSON('/admin/products/'+dataProductID+'/variants.json', function (variant) {
                $.each(variant, function(indexvariant, itemvariant) {
                  $.each(itemvariant, function(indexvarianti, itemvarianti) {
                    var numqty = itemvarianti.inventory_quantity;
                    sumqty += (numqty || 0);
                  });
                });
                $(".countdow-product").find(".count").html(sumqty);
            }); 

            var l = $(".countdow-product");
            var variant = parseInt($(".countdow-product").find(".count").text());
            var count = variant+sumqt;
            var variantqty = 100*(variant/count);
            l.find(".progressbar").addClass("active progress-striped");
            setTimeout(function() {
              l.find(".progressbar div").css("width", variantqty + "%");
              l.find(".progressbar").removeClass("active progress-striped");
            }, 300) 
          });
      }, 10000)
    }
  }
  progressbar();
});
jQuery(document).ready(function($){
  $('.click-show-menu').click(function(){
      if(!$('.click-open').hasClass('show-menu')){
          $('.click-open').addClass('show-menu');$('.click-show-menu').children('i').removeClass('icon-align-right').addClass('icon-x');
      }else{
          $('.click-open').removeClass('show-menu');$('.click-show-menu').children('i').removeClass('icon-x').addClass('icon-align-right');
      }return false;
  });
});
jQuery(document).ready(function($){
  var start_countdown = Date.parse(new Date($('.bts-countdown').data("datetime")));
  function pad(num) {
    return ("0" + Math.floor(num)).substr(-2);
  }
    
  function tick_countdown() {
    var now = Date.parse(new Date);
    if (now > start_countdown){
       start_countdown = Date.parse(new Date);
    }
    var _time = $('.bts-countdown'),
        _days = _time.find('.days .number'),
		_hour = _time.find('.hour .number'),
		_minute = _time.find('.mins .number'),
		_second = _time.find('.secs .number');
    var remain = ((start_countdown - now) / 1000);
    var day = Math.floor(remain / 86400 );
    var hh = Math.floor((remain / 60 / 60) % 24);
    var mm = pad((remain / 60) % 60);
    var ss = pad(remain % 60);
    _days.text(day);
	_hour.text(hh);
    _minute.text(mm);
    _second.text(ss);
    setTimeout(tick_countdown, 1000);
  }
  tick_countdown();
  document.addEventListener('DOMContentLoaded', tick_countdown);
});

jQuery(document).ready(function($){
  var start_countdown_banner = Date.parse($('.bts-countdown-banner').data("datetime"));
  function pad(num) {
    return ("0" + parseInt(num)).substr(-2);
  }
  

  function tick_countdown_banner() {
    var now = new Date;
    if (now > start_countdown_banner){
       start_countdown_banner = new Date;
    }
    var _time = $('.bts-countdown-banner'),
        _days = _time.find('.days .number'),
		_hour = _time.find('.hour .number'),
		_minute = _time.find('.mins .number'),
		_second = _time.find('.secs .number');
    var remain = ((start_countdown_banner - now) / 1000);
    var day = parseInt(remain / 86400 );
    var hh = parseInt((remain / 60 / 60) % 24);
    var mm = pad((remain / 60) % 60);
    var ss = pad(remain % 60);
    _days.text(day);
	_hour.text(hh);
    _minute.text(mm);
    _second.text(ss);
    setTimeout(tick_countdown_banner, 1000);
  }
  tick_countdown_banner();
  document.addEventListener('DOMContentLoaded', tick_countdown_banner);
});
